// USA
export const locale = {
  lang: 'en',
  data: {
    LOGIN_WITH_EMAIL:{
      TITLE: 'Login With Email'
    },
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    LOGOUT: {
      MESSAGE: 'LOGOUT',
      CONFIRMATION: {
        MESSAGE: 'Are you sure you want to log out?',
      },
    },
    POCKET_RA: {
      HCC_CODE:'HCC Code',
      DIAGNOSIS_CODE: 'Diagnosis Code',
      CLASSIFICATION: 'Classification',
      DESCRIPTION: 'Description',
      ICD10:'ICD10',
      ICD10_DESCRIPTION:'ICD10 Description'
    },
    TABS_POCKETS_GUIDES:{
      QUALITY: 'Quality',
      RISK_ADJUSTMENT: 'Risk Adjustment'
    },
    KPI_STARTS:{
      TOTAL:'Total Open GIC',
      TOTAL_RA:'Total Members RA',
      TOTAL_MEMBERS:'Members Without Visits'
    },
    PATIENT:{
      UPDATE_NO_SHOW :'Are you sure you want to mark the patient as No Show?',
      PATIENT_PROFILE:'Patient Profile',
      PATIENT_VISIT: 'Are you sure you want to mark the patient\'s gap?',
      PATIENT_CANCELED: "Are you sure you want to cancel the patient\'s visit?",
      ERROR_CANCEL_VISIT:"Error Canceling Visit",
      NO_RECORDS_FOUND: 'No records found.'
    },
    REPORTS:{
      TODAY: 'TODAY',
      MISSED: 'Missed',
      COMPLETED: 'Completed',
      RANK: 'RANK'
    },
    MY_SCHEDULE: {
      DATATABLE_HEADERS: {
        NAME: 'Name',
        STATUS: 'Status',
        DATE: 'Date',
        TIME: 'Time',
        GIC: 'GIC',
        RA: 'RA'
      },
        TABS: {
          ALL: "All",
          PENDING: "Pending",
          NO_SHOW: "No Show",
          COMPLETED: "Completed"
        }
    },

    DASHBOARD: {
      GAP_TOTAL: 'Total Appt <br/> (Patients)',
      GAP_COMPLETED: 'Total Seen',
      GAP_PENDING: 'Total No-show',
      GAP_EXECUTION: 'Performance',
      RA_TOTAL: 'Total RA <br/> Recommended',
      RA_COMPLETED: 'Total RA Complete',
      RA_PENDING: 'Total RA Missed',
      RA_EXECUTION: 'Performance',
      SCHEDULE_TOTAL: 'Total GIC <br/> Recommended',
      SCHEDULE_COMPLETED: 'Total GIC Confirmed',
      SCHEDULE_PENDING: 'Total GIC Missed',
      SCHEDULE_EXECUTION: 'Performance',
      MY_PANEL: 'My Panel',
      MY_SCHEDULE: 'My Schedule',
      TODAY: 'Today'
    },
    SECURITY: {
      STATUS_USER_QUESTION:
        'Are you sure you want to change the status of this user?',
      STATUS_USER_TITLE: 'Change User Status',
    },
    DIGITAL_CARD: {
      ADD_CARD: 'Add Digital Card',
      UPLOAD_CARD: 'Upload Digital Card',
      SEND_EMAIL:
        'Are you sure you want to send the email with the digital card?',
      SUCCESS_EMAIL: 'The email(s) has/have been sent successfully.',
    },
    MENU: {
      QUALITY_SCORECARD: 'Quality Scorecard',
      INVITATION: 'Invitation',
      ADD_INVITATION:'Add Invitation',
      REPORT_A_BUG: 'Report a Bug',
      PRACTICE_INVITATION:'Practice Invitation',
      ABOUT_US:'About Us',
      MY_SCHEDULE: 'My Schedule',
      MY_PATIENTS: 'My Patients',
      DIGITAL_CARDS: 'Digital Cards',
      LOGS: 'Logs',
      UNROLL_PROVIDERS: 'UnRoll Providers',
      UNROLL_PRACTICES: 'UnRoll Practices',
      GENERAL_CONFIGURACION: 'General Configuration',
      PROFILE: 'Profile',
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      SESSIONS: 'Sessions',
      DASHBOARD: 'Dashboard',
      POCKET_GUIDE: 'Pocket Guides',
      MONITOR: 'Monitor',
      APPROVALS: 'Approvals',
      SETTINGS: 'Settings',
      HOME: 'Home',
      WITHDRAWALS: 'Withdrawals',
      TRANSACTIONS: 'Transactions',
      WORKLIST: 'Worklist',
      OVERVIEW: 'Overview',
      NOTIFICATIONS: 'Notifications',
      CUTOFF_BILLING: 'Cutoff Billing',
      ACTIVITIES: 'Activities',
      ACCOUNT: 'Account',
      ACCOUNTS: 'Accounts',
      CATALOG: 'Catalog',
      REQUESTS: 'Requests',
      APPLICATIONS: 'Applications',
      PERMISSIONS: 'Permissions',
      MENUS: 'Menus',
      PROFILES: 'Profiles',
      ASSOCIATIONS: 'Associations',
      OPTIONS: 'Options',
      SECURITY: 'Security',
      VERIFICATION_REQUEST_PRACTICE: 'Verification Request Practices',
      VERIFICATION_REQUEST_USERS: 'Verification Request Users',
      ROLES: 'Roles',
      PRACTICES: 'Practices',
      MODULES: 'Modules',
      CATEGORIES: 'Categories',
      MENU: 'Menu',
      USERS: 'Users',
      SERVICES: 'Services',
      CLAIM_TYPES: 'Claim Types',
      LANGUAGES: 'Languages',
      MESSAGES: 'Messages',
      PARAMETERS: 'Parameters',
      PLATFORMS: 'Platforms',
      USIO: 'USIO',
      GENERAL: 'General',
      CHANGE_PASSWORD: 'Change Password',
      ACCOUNT_TYPES: 'Account Types',
      APPLICATION_GROUPS: 'Application Groups',
      ADD_APPLICATION_GROUP: 'Add Application Group',
      PRACTICE_INVITATIONS: 'Practice Invites',
      APPLICATION_MONITOR: { ACTIVITIES: 'Monitor Activities' },
    },
    SIDEBAR_MENU: {
      SETTINGS: 'Settings',
      LOGOUT: 'Log Out'
    },
    CREATE:
      {
        WALK_IN: 'Created Walk-In'

      },
    REPORT:{
      ID:'Id',
      MEASURE_CODE:'Measure Code',
      DESCRIPTION:'Description',
      MEASURE_DESCRIPTION:'Measure Description',
      COMPLETE:'Complete',
      CREATED:'Created',
      LOCATION_NAME:'Location Name',
      PROVIDER_NAME: 'Provider Name',
      TREATED_PROVIDER_NAME:'Treated Provider Name',
      TREATED_PROVIDER_ID:'Treated Provider Id',
      SOMOS_PROVIDER_ID:'SOMOS Provider Id',
      SOMOS_MEMBER_ID:'SOMOS Member Id',
      MEMBER_NAME: 'Member Name',
      LOCATION:'Location',
      BILLING_TIN:'Billing Tin',
      TREATED_PROVIDER:'Treated Provider',
      PROVIDER:'Provider',
      HCC_CATEGORY:'HCC Cat',
      HCC_DESCRIPTION:'HCC Description',
      ICD10_CODES:'ICD10 Codes',
      INACTIVE:'Inactive',
      PRESENT:'Present',
      APP:'APP',
      MCO:'MCO',
      MISSED_DATE:'MISSED DATE',
      LAST_DOS:'LAST DOS',
      ADDRESS:'ADDRESS',
      PHONE:'PHONE',
      DOB:'DOB',
      NAME:'NAME',
      APPT: 'APPT',
      MEASURE:'MEASURE',
      STATUS:'STATUS',
      HCC_ICD10:'HCC/ICD10',
      SUCCESS_EXPORT:'The report has been successfully exported.',
      ERROR_EXPORT:'An error occurred while exporting the report. Please try again later.'
    },

    GENERAL: {
      DATE_RANGE:'Date Range',
      HCC:'HCC',
      LOGOUT: 'Log Out',
      CARE_GAPS: 'Care Gaps',
      RISK_ADJUSTMENT:'Risk Adjustment',
      PRESENT:'Present',
      EXPORT_TO_EXCEL:'Export to Excel',
      EXPORT:'Export',
      GAP:'GAP',
      INACTIVE: 'Inact',
      ICD10:'ICD 10',
      PROVIDER:'Provider',
      CLEAR:'Clear',
      DOB: 'DOB',
      APPT:'APPT',
      MCO: 'MCO',
      MEASURE:'MEASURE',
      PATIENT_PROFILE:'Patient Profile',
      APP:'App',
      EHR:'EHR',
      CLAIM:'Claim',
      WALK_IN:'Walk-In',
      CLOSE:"Close",
      JOB_TITLE: "Job Title",
      COMPANY: "Company",
      WEB_LINK: "Web Link",
      FROM: 'From',
      TO: 'To',
      SUBJECT: 'Subject',
      MESSAGE: 'Message',
      OPTION: 'Option',
      MENU: 'Menu',
      ROL: 'Profile',
      PARAMETER_VALUE: 'Value',
      ACTIVITY: 'Activity',
      LEVEL: 'Level',
      SEND_EMAIL: 'Send Email',
      MODULE: 'Module',
      APPLICATION: 'Application',
      LAST_LOGIN: 'Last Login',
      DOWNLOAD_RESPONSE: 'Download Response',
      ACTIVE: 'Active',
      PERIOD: 'Period',
      PROFILE: 'Profile',
      USERS: 'Users',
      VIEW_ACCOUNT: 'View Accounts',
      PRACTICE_NAME: 'Practice Name',
      ROLE_NAME: 'Profile Name',
      IS_VERIFIED: 'Is Verified',
      REQUEST_TYPE: 'Type',
      MCO_NAME: 'MCO',
      GIC: 'GIC',
      RA: 'RA',
      NU: 'Non-users',
      FULL_NAME: 'Full Name',
      DETAILS: 'Details',
      LANGUAGE: {
        TITLE: 'Language',
        ENGLISH: 'English',
        SPANISH: 'Spanish'
      },
      CHANGE_PWD: 'Change Password',
      COUNT_USERS: 'Count Users',
      EMAIL_USER: 'Email',
      PROCESS: 'Process',
      DOWNLOAD_TEMPLATE: 'Download Template',
      UPLOAD_FILE: 'Upload File',
      SEND_INVITATIONS: 'Send Invitation',
      PRACTICE_INFORMATION: 'Practice Information',
      USER_INFORMATION: 'User Information',
      PHONE_NUMBER: 'Phone Number',
      EDIT_FILTER: 'Filter',
      APPLY_FILTER: 'Apply Filter',
      CLEAR_FILTER: 'Clear Filter',
      FILTER: 'Filter',
      APPLY: 'Apply',
      DELIVERED_EMAIL: 'Email Delivered?',
      ACTION: 'Action',
      NPI: 'NPI',
      PROVIDER_NAME: 'Provider',
      NSI: 'TIN',
      SUMMARY: 'Summary',
      CITY: 'City',
      STATE: 'State',
      DENY: 'Deny',
      ACCEPT: 'Accept',
      REQUEST_VERIFICATION: 'Request Verification',
      REQUEST_NUMBER: 'Request Number',
      PRACTICE: 'Practice',
      ROLE: 'Profile',
      PHONE: 'Phone',
      LOADING: 'Please wait...',
      CONTINUE: 'Continue',
      WELCOME: 'Welcome',
      NAME: 'Name',
      DATE: 'Date',
      TIME: 'Time',
      ALERT: 'Alert',
      REQUEST_NOT_FOUND: 'Unregistered requests.',
      REQUEST_NOT_FOUND_MESSAGE:
        'At this time, you do not have registered product requests.',
      ADD_CREDIT_CARD: 'Add Credit Card',
      SEND_REQUEST_VERIFICATION: 'Send verification request',
      CREDIT_CARD_NOT_DEFINED: 'You do not have a registered credit card',
      CREDIT_CARD_NOT_DEFINED_MESSAGE:
        'Add a credit card where we can process your payments.',
      BANK_ACCOUNT_NOT_DEFINED: 'You do not have registered bank accounts',
      BANK_ACCOUNT_NOT_DEFINED_MESSAGE:
        'You can register your bank account for your deposits or automatic payments.',
      MY_BANK_ACCOUNTS: 'My Bank Accounts',
      ADD_BANK_ACCOUNT: 'Add Bank Account',
      EDIT_PROFILE: 'Edit Profile',
      ADDRESS_SETTINGS: 'Address Settings',
      CONTACT_SETTINGS: 'Contact Settings',
      ACCOUNT_NUMBER: 'Account Number',
      CARD_NUMBER: 'Card Number',
      LIST_REQUESTS: 'Product Request List',
      LIST_REQUEST_PRODUCTS:
        'List of your requests for financial products and services',
      PLACEHOLDER_CARD_NUMBER: '5555 5555 5555 5555',
      EXP_MONTH: 'Exp. Month',
      EXP_YEAR: 'Exp. Year',
      EXPIRATION: 'Expiration',
      CVV: 'CVV',
      PLACEHOLDER: 'Placeholder',
      MY_CARDS: 'My Cards',
      IS_ENABLED: 'Is Enabled',
      IS_BUSINESS: 'Is Business',
      IS_DEFAULT: 'Is Default',
      NO_DEFAULT: 'No Default',
      DEFAULT: 'Default',
      PAYMENT_METHOD: 'Payment method',
      DEBIT_CARD: 'Debit Card',
      CREDIT_CARD: 'Credit Card',
      YOUR_NEED_SET_PAYMENT_METHOD:
        'You need to configure your payment method.',
      YOUR_NEED_SET_PAYMENT_METHOD_ACCESS:
        'Configure your payment and deposit methods, in the following access, please',
      ADD_PAYMENT_METHOD: 'Add Payment Method',
      ACH: 'ACH',
      ACCOUNT_TYPE: 'Account Type',
      ACCOUNT_INFO: 'Account Info',
      ADDRESS: 'Address',
      IDENTITY_DOCUMENT: 'Document',
      CONTACTS: 'Contacts',
      COMPLETED: 'Completed',
      CURRENT: 'Corriente',
      ROUTING_NUMBER: 'Routing Number',
      BANK_ACCOUNT_TYPE: 'Account Type',
      SAVINGS: 'Savings',
      CASH: 'CASH',
      STATUS: 'Status',
      ENABLED: 'Enabled',
      DISABLED: 'Disabled',
      BUSINESS: 'Business',
      CUSTOMER: 'Customer',
      BANK: 'Bank',
      FULLNAME: 'Fullname',
      PLACEHOLDER_ACCOUNT_NUMBER: 'Enter your bank account number.',
      PLACEHOLDER_ROUTING_NUMBER: 'Enter your bank account routing number.',
      AUTHENTICATION: 'Authentication',
      CODE: 'Code',
      IS_SANDBOX: 'Is SandBox',
      EMAIL: 'Email',
      FEE: 'Fee',
      FEE_CENTS: 'Fee Cents',
      TYPE: 'Type',
      NEW: 'New',
      WARNING: 'Warning',
      WARING_DELETE_RECORD:
        'You are trying to delete this record. Do you want to continue the operation?',
      NATIVE_NAME: 'Native Name',
      TRANSACTION_TYPE: 'Transaction Type',
      PLACEHOLDER_CODE: 'Enter unique code',
      PLACEHOLDER_EMAIL: 'Enter email',
      ISO_CODE: 'ISO Code',
      EARNINGS: 'Earnings',
      POINTS: 'Point(s)',
      OVERVIEW: 'Overview',
      SETTINGS: 'Settings',
      BANK_ACCOUNT: 'Bank Accounts',
      ACCOUNT: 'Account',
      CREDIT_LIMIT_USAGE: 'Credit limit usage',
      SCORE: 'Score',
      LIMIT_CREDIT: 'Limit credit',
      YES: 'Yes',
      KEY: 'APP KEY',
      SECRET: 'Secret',
      TOKEN: 'Token',
      WEBHOOK_SECRET: 'Webhook Secret',
      PLACEHOLDER_KEY: 'Enter App Key',
      PLACEHOLDER_SECRET: 'Enter secret',
      PLACEHOLDER_TOKEN: 'Enter token',
      PLACEHOLDER_WEBHOOK_SECRET: 'Enter webhook secret',
      PLACEHOLDER_FEE: 'Enter fee',
      PLACEHOLDER_FEE_CENTS: 'Enter fee cents',
      NATIONALITY_COUNTRY: 'Nationality Country',
      RELATIONSHIP_SINGLE: 'Single',
      RELATIONSHIP_MARRIED: 'Married',
      RELATIONSHIP_DIVORCED: 'Divorced',
      RELATIONSHIP_WIDOWED: 'Widowed',
      NO: 'No',
      OK: 'OK',
      ADD: 'Add',
      ID: 'ID',
      NOTIFICATIONS: 'Notifications',
      HELP_CENTER: 'Help Center',
      MAIN_INFO: 'Main Information',
      LIMIT: 'Limit',
      CHARGE: 'Charge',
      FIRST_NAME: 'First Name',
      PLACEHOLDER_FIRST_NAME: 'Enter your first name',
      LAST_NAME: 'Last Name',
      PLACEHOLDER_LAST_NAME: 'Enter your last name',
      BIRTHDATE: 'Birthdate',
      PROFILE_DETAILS: 'Profile details',
      REQUEST_NEW_PRODUCTS: 'Request new products',
      PLACEHOLDER_COMMENT: 'Enter a brief comment',
      GENDER: 'Gender',
      SINGLE: 'Single',
      REQUEST_VERIFICATION_IN_PROCESS: 'Verification request in process',
      REQUEST_VERIFICATION_IN_PROCESS_MESSAGE:
        'We have received your verification request and we are in the process of evaluating it.',
      RELATIONSHIP_STATUS: 'Relationship Status',
      OCCUPATION: 'Occupation',
      MONTHLY_EARNINGS: 'Monthly Earnings',
      BIRTH_COUNTRY: 'Birth country',
      PLACEHOLDER_MONTHLY_EARNING: 'Enter the amount of your monthly income.',
      DESCRIPTION: 'Description',
      COUNTRY: 'Country',
      FEMALE: 'Female',
      MASCULINE: 'Masculine',
      ADDRESS_INFO: 'Address Info',
      ADDRESS1: 'Address 1',
      PLACEHOLDER_ADDRESS1: 'Room/Department, Floor, House Name',
      ADDRESS2: 'Address 2',
      PLACEHOLDER_ADDRESS2: 'Building Number, Street',
      STATE_OR_PROVINCE: 'State/Province/Department',
      ZIP_CODE: 'Zip Code',
      IDENTITY_DOCUMENT_INFO: 'Accreditation documents',
      IDENTITY_DOCUMENT_NUMBER: 'Document Number',
      PLACEHOLDER_IDENTITY_DOCUMENT_NUMBER:
        'Enter the identity document number',
      FRONT_PHOTO: 'Front photo',
      FRONT_PHOTO_UPLOAD:
        'Drag here the back photo of the identity document card.',
      BACK_PHOTO: 'Back photo',
      BACK_PHOTO_UPLOAD:
        'Drag here the back photo of the identity document card.',
      PLACEHOLDER_ZIP_CODE: 'NY 10118',
      INSTRUCTION: 'Instruction',
      BUSINESS_NAME: 'Business Name',
      CREATE_ACCOUNT_COMPLETED:
        'Congratulations, we have concluded with the creation of your account.',
      CREATE_ACCOUNT_COMPLETED_MESSAGE:
        'Now that you have completed the information required for your account, within 24 hours we will review your information and, if possible, we will contact you to validate some information.',
      PLACEHOLDER_PHONE_NUMBER: '(999) 999-99999',
      INFO_CONTACT: 'Contact Info',
      CONTACT_HOME: 'Contact Home',
      CONTACT_WORK: 'Contact Work',
      CONTACT_WHATSAPP: 'Contact Whatsapp',
      PLACEHOLDER_BUSINESS_NAME: 'Enter the business name',
      TRADE_NAME: 'Trade name',
      PLACEHOLDER_TRADE_NAME: 'Enter the trade name of business',
      LEGAL_REPRESENTATIVE_NAME: 'Legal representative name',
      PLACEHOLDER_LEGAL_REPRESENTATIVE_NAME:
        'Enter representative name of business',
      LEGAL_REPRESENTATIVE_EMAIL: 'Legal representative email',
      PLACEHOLDER_LEGAL_REPRESENTATIVE_EMAIL:
        'Enter representative email of business',
      LEGAL_REPRESENTATIVE_PHONE: 'Legal representative phone',
      PLACEHOLDER_LEGAL_REPRESENTATIVE_PHONE:
        'Enter representative phone number of business',
      ANNUAL_EARNINGS: 'Annual Earnings',
      PLACEHOLDER_ANNUAL_EARNINGS:
        'Enter the amount of annual business income.',
      INFORMATION_REQUIRED: 'Information Required',
      DELETE: 'Delete',
      CREATED: 'Created',
      MODIFIED: 'Modified',
      EDIT: 'Edit',
      GENERATE: 'Generate',
      PREVIOUS: 'Previous',
      ABOUT: 'About',
      SAVE: 'Save',
      DURATION: 'Duration',
      CANCEL: 'Cancel',
      PLACEHOLDER_NAME: 'Enter name',
      SEARCH: 'Search',
      BASIC_INFO: 'Basic Info',
      MIN_LIMIT: 'Min Limit',
      MAX_LIMIT: 'Max Limit',
      LOGO: 'Logo',
      DAILY_MAXIMUM_LIMIT: 'Daily Maximum Limit',
      MONTHLY_MAXIMUM_LIMIT: 'Monthly Maximum Limit',
      DAILY_TOTAL_TRANSACTION: 'Daily Total Transaction',
      PROCESSING_TIME: 'Processing Time',
      CHARGE_TYPE: 'Charge Type',
      CHARGE_AMOUNT: 'Charge Amount',
      FIXED: 'Fixed',
      PERCENTAGE: 'Percentage',
      METRICS: 'Metrics',
      OTHERS: 'Others',
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      MONTHLY: 'Monthly',
      YEARLY: 'Yearly',
      PLACEHOLDER_DESCRIPTION: 'Enter the description',
      ON_REGISTERED_SUCCESSFULLY:
        'The information was registered successfully.',
      CONGRATULATIONS: 'Congratulations',
      ON_SESSION_EXPIRED_TITLE: 'Session expired',
      ON_SESSION_EXPIRED_MESSAGE:
        'For security reason, we have expired his session due to inactivity. Please login again.',
      ERRORS: {
        AN_ERROR_HAS_OCCURRED: 'An error has occurred',
        AN_ERROR_WHEN_SAVED:
          'An error occurred while saving the record. Please make sure that all required data are properly completed. If the problem persists, please contact the system administrator.',
        AN_LOCK_WHEN_DELETED:
          'The record you are trying to delete has dependencies and can not be deleted. Please delete the dependencies before deleting this record.',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        FIELD_INVALID: 'The entered value is invalid, please verify.',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'Invalid user or password. Please check',
        SESSION_LIMIT:
          'This user account is being used on another computer. If you are the owner of this account, please contact the administrator to enable the account.',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        EMAIL_INVALID: 'The email entered is invalid, please verify.',
      },
    },
    PROFILE: {
      EDIT_PROFILE: 'Edit Profile',
      ADD_PROFILE: 'Add Profile',
      PROFILE_TYPE: 'Profile Type',
    },
    VERIFICATIONS: {
      REQUEST_VERIFICATION: 'Request Verification',
      SHOW_REQUEST: 'Show Request',
      PRACTICE_INFO: 'Practice Info',
      SUMMARY: 'Summary',
      PENDING: 'Pending',
      ACCEPTED: 'Accepted',
      DENIED: 'Denied',
      REQUEST_ACCEPT: 'Verification request acceptance',
      REQUEST_DENY: 'Verification request denial',
      REQUEST_ACCEPT_MESSAGE:
        'You are trying to accept this invitation, once you confirm acceptance, the requested permissions will be granted to the users found in the request.',
      REQUEST_DENY_MESSAGE:
        'You are trying to deny this invitation, once you confirm the denial, the requested permissions will not be granted to the users in the request.',
      INPUT_COMMENT_ACCEPT:
        'Please enter a brief comment about the reasons for acceptance.',
      INPUT_COMMENT_DENY:
        'Please enter a brief comment about the reasons for denial.',
    },
    AUTH: {
      CONFIRM_PASSWORD: 'Confirm Password',
      CHANGE_PWD: 'Change Password',
      OLD_PASSWORD: 'Old Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_NEW_PASSWORD: 'Confirm Password',
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        SIGN_IN_METHOD: 'Sign-in Method',
        TERMS: 'Terms',
        LEGAL: 'Legal',
        CONTACT: 'Contact Us',
        AGREEMENT_MESSAGE: 'I Agree the ',
        TERMS_AND_CONDITIONS: 'terms and conditions',
        ABOUT: 'About',
        WELCOME: 'Welcome to {{name}}',
        CONTINUE_GOOGLE: 'Continue with Google',
        NEW_HERE: 'New Here?',
        UPDATE_EMAIL: 'Update Email',
        CHANGE_EMAIL: 'Change email',
        RESET_PASSWORD: 'Reset Password',
        SECURE_YOUR_ACCOUNT: 'Secure Your Account',
        TWO_FACTOR_MESSAGE:
          "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code",
        PASSWORD_REQUIRED: 'Password is required',
        PASSWORD_MINLENGTH: 'Password should have at least 8 characters',
        PASSWORD_MAXLENGTH: 'Password should have maximum 30 characters',
        EMAIL_REQUIRED: 'Email is required',
        EMAIL_INVALID: 'Email is invalid',
        EMAIL_MINLENGTH: 'Email should have at least 3 symbols',
        EMAIL_MAXLENGTH: 'Email should have maximum 180 symbols',
        CONFIRM_PASSWORD_REQUIRED: 'Confirm Password is required',
        CONFIRM_PASSWORD_MINLENGTH:
          'Confirm Password should have at least 8 symbols',
        CONFIRM_PASSWORD_MAXLENGTH:
          'Confirm Password should have maximum 100 symbols',
        PASSWORDS_NOT_MATCH: "'Passsword' and 'Confirm Password' didn't match.",
        MESSAGE_PERSONAL_AUTHORIZATION:
          'This portal is for {{name}} authorized personnel only. Access sharing credentials for unauthorized access is prohibited.',
      },

      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
        EMAIL: 'Email',
        USERNAME_OR_EMAIL: 'Username or Email',
        PASSWORD: 'Password',
        USERNAME_OR_EMAIL_REQUIRED: 'Username or Email is required',
        USERNAME_OR_EMAIL_INVALID: 'Username or Email is invalid',
        USERNAME_OR_EMAIL_MINLENGTH:
          'Username or Email should have at least 3 characters.',
        USERNAME_OR_EMAIL_MAXLENGTH:
          'Username or Email should have maximum 360 characters',
        SIGN_IN_TO: 'Sign In to Aidia',
        LOGIN_FAILED_MESSAGE: 'The login details are incorrect',
        FORGOT_PASSWORD: 'Forgot your password?',
        MESSAGE_PERSONAL_AUTHORIZATION:
          'This portal is for {{name}} authorized personnel only. Access sharing credentials for unauthorized access is prohibited.',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        CREATE_ACCOUNT: 'Create an Account',
        ALREADY_HAVE_ACCOUNT: 'Already have an account?',
        REGISTER_INCORRECT: 'The registration details are incorrect',
      },
      INPUT: {
        EMAIL: 'Email Address',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
        ENTER_NEW_EMAIL: 'Enter New Email Address',
        CONFIRM_EMAIL: 'Confirm Password',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        PASSWORD_MISMATCH: 'The passwords do not match. Please try again.',
        NUMERIC_PASSWORD:
          'Your password cannot be entirely numeric. Please include letters or special characters.',
      },
    },
    ROLES: {
      ROLE_TYPE: 'Profile Type',
      NAME: 'Profile Name',
      USER: 'User',
      ASSOCIATION: 'Association',
      MANAGER: 'Manager',
      PROVIDER: 'Provider',
      ASOCIATION: 'Association',
      PRACTICE_REQUIRED: 'Practice required',
      ADD_ROLE: 'Add Profile',
      EDIT_ROLE: 'Edit Profile',
      VERIFICATION_REQUIRED: 'Verification Required',
    },
    KYC: {
      CHOOSE_ACCOUNT_TYPE: 'Choose Account Type',
      CHOOSE_ACCOUNT_TYPE_HELP: 'If you need more info, please check out',
      PERSONAL_ACCOUNT: 'Personal Account',
      PERSONAL_ACCOUNT_INFO: 'If you need more info, please check it out',
      BUSINESS_ACCOUNT: 'Business Account',
      BUSINESS_ACCOUNT_INFO: 'If you need more info, please check it out',
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    ACCOUNT_TYPES: {
      ADD_ACCOUNT_TYPE: 'Add Account Type',
      EDIT_ACCOUNT_TYPE: 'Edit Account Type',
    },
    OCCUPATIONS: {
      ADD_OCCUPATION: 'Add Occupation',
      EDIT_OCCUPATION: 'Edit Occupation',
    },
    INVITATION: {
      LIST_UNROLL_USERS: 'List Users',
      LIST_PRACTICE_INVITATIONS: 'List Practice Invitations',
      SUCCESS_CHANGE_NOTIFICATION_INVITATION:
        'The delivery status of the mail has been changed.',
      FILTER: 'Filter',
      UPLOAD_INVITATION: 'Upload Invitations',
      ADD_INVITATION: 'Add Invitation',
      SEND_INVITATIONS: 'Practice Invitation',
      TITLE: 'Invitations',
      RESEND_INVITATION: 'Are you sure you want to resend the invitation?',
      RESEND_INVITATION_TITLE: 'Resend Invitation',
      SELECT_INVITATION: 'No records selected',
      SUCCESS_RESEND_INVITATION: 'The invitation has been successfully resent',
      SUCCESS_CANCELED_INVITATION:
        'The invitation has been successfully canceled',
      INCORRECT_FORMAT: 'The file does not have the correct format',
      UPLOAD_FILES: 'Upload Files',
      PROCESS_FINISHED: 'The process has finished',
      EDIT_SEND_INVITATIONS: 'Edit Invitation',
      CANCEL_INVITATION: 'Are you sure you want to cancel the invitation?',
    },
    TRANSACTIONS: {
      ADD_TRANSACTION_TYPE: 'Add Transaction Type',
      EDIT_TRANSACTION_TYPE: 'Edit Transaction Type',
      ADD_BILLCYCLE: 'Add Billcycle',
      EDIT_BILLCYCLE: 'Edit Billcycle',
      ADD_BANK: 'Add Bank',
      EDIT_BANK: 'Edit Bank',
      TYPE_CODE: 'Type Code',
      INTEREST: 'Interest',
      PAYMENT: 'Payment',
      TAX: 'Tax',
      DISBURSEMENT: 'Disbursement',
      CHARGE: 'Charge',
      CREDIT: 'Credit',
      ADJUSTMENT: 'Adjustment',
      CUTOFF_DATE: 'Cutoff Date',
      LAST_CUTOFF_DATE: 'Last Cutoff',
      INTERVAL_TYPE: 'Interval Type',
      INTERVAL_QTY: 'Interval Qty.',
    },
    CASH: {
      ADD_DEPOSIT_CONCEPT: 'Add Deposit Concept',
      EDIT_DEPOSIT_CONCEPT: 'Edit Deposit Concept',
      ADD_PAYMENT_CONCEPT: 'Add Payment Concept',
      EDIT_PAYMENT_CONCEPT: 'Edit Payment Concept',
      ADD_PAYMENT_GATEWAY: 'Add Payment Gateway',
      EDIT_PAYMENT_GATEWAY: 'Edit Payment Gateway',
    },
    VIEW: {
      PRACTICES: 'View Practices',
      UNLINK_USER_PROVIDER: 'Unlink User from Provider',
      UNLINK_USER_OWNER: 'Unlink User from Owner',
      USERS: 'View Users',
    },
    ACCOUNTS: {
      VIEW_DETAILS_ACCOUNT: 'View Details Accounts',
      ROLE_ID: 'Role',
      PROFILE: 'Profile',
      ASSOCIATION_ID: 'Association',
      SUPER_ADMIN: 'Super Admin',
      CREATE_SUPER_ADMIN: 'Create Super Admin',
      EDIT_SUPER_ADMIN: 'Edit User',
      ENABLE_DISABLE: 'Enable/Disable',
      STATUS_HEADER: 'Enable or Disable user',
      STATUS_CONFIRMATION_MESSAGE:
        'Are you sure you want to change the status of this user?',
      STATUS_BUTTOM: 'Enable or Disable this user',
    },
    SYSTEM_GENERAL: {
      SAVE_TITLE: 'General Configuration',
      SUCCESS_MESSAGE: 'Configuration Has Been Updated',
    },
  },
};
